// extracted by mini-css-extract-plugin
export default {"termOfUse__wrapper":"TermOfUse_termOfUse__wrapper__Y59QJ","contactUs__content":"TermOfUse_contactUs__content__PE9vQ","text_block":"TermOfUse_text_block__Ujl+a"};